/* eslint-disable import/prefer-default-export */
import queryString from 'query-string';
import { generatePath } from 'react-router-dom';

import { API_AD_GROUP_DESTINATIONS_BATCH_UPDATE_URL, API_AD_GROUP_DESTINATIONS_URL } from '../../constants/apiUrls';
import { Location } from '../../constants/locationTable';
import { PageableList } from '../../types/contract';
import { getRequestJSON, postRequestJSON } from '../../util/services';

interface QueryParams {
  page?: number;
  perPage?: number;
}

export const get = (
  apiHost: string,
  adGroupId: number,
  { page, perPage }: QueryParams
): Promise<PageableList<Location>> => {
  const queryParams = `?${queryString.stringify({
    page: page + 1,
    per_page: perPage,
  })}`;
  return getRequestJSON(
    apiHost,
    generatePath(API_AD_GROUP_DESTINATIONS_URL, { adGroupId: adGroupId.toString(), '*': queryParams })
  );
};

export const batchUpdate = (apiHost: string, adGroupId: number, payload): Promise<any> =>
  postRequestJSON(
    apiHost,
    generatePath(API_AD_GROUP_DESTINATIONS_BATCH_UPDATE_URL, {
      adGroupId: adGroupId.toString(),
    }),
    payload
  );
